import { render, staticRenderFns } from "./DWChart.vue?vue&type=template&id=6d373ae8&scoped=true&"
import script from "./DWChart.vue?vue&type=script&lang=js&"
export * from "./DWChart.vue?vue&type=script&lang=js&"
import style0 from "./DWChart.vue?vue&type=style&index=0&id=6d373ae8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d373ae8",
  null
  
)

export default component.exports